import * as yup from 'yup';

export const OpenIdConfigurationUpdateSchema = yup.object().shape({
  name: yup.string().required('Name is required'),
  configuration: yup.object().shape({
    clientId: yup.string().required('Client ID is required'),
    authority: yup.string().url('Authority must be a valid URL').required('Authority is required'),
  }),
});
